// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JUVe","placeholdersHeader":"styles_placeholdersHeader__3FSUz","editorStyle":"styles_editorStyle__2jRKA","placeholdersBox":"styles_placeholdersBox__3J36-"};